export const PROCESSED_EXCEL = 'PROCESSED_EXCEL';
export const TRANSFORMING = 'TRANSFORMING';